import React, { useState } from 'react';
import { string, oneOf } from 'prop-types';
import classnames from 'classnames';
import './style.scss';

const ClientLogo = ({
    logoPath,
    name,
    logoContainerClassName,
    logoClassName,
    size = ClientLogo.SIZES.MEDIUM
}) => {
    const [errorLoading, setErrorLoading] = useState(false);
    const classes = classnames('notable-client-logo-wrap', size, logoContainerClassName, { 'hide-on-error': errorLoading });

    const imageError = () => {
        setErrorLoading(true);
    };

    return (
        <div className={classes}>
            <img className={classnames('logo-image', logoClassName)} src={logoPath} alt={name} onError={imageError}/>
        </div>
    );
};

ClientLogo.SIZES = {
    BIG: 'big',
    MEDIUM: 'medium',
    MEDIALL: 'mediall',
    SMALL: 'small',
    TINY: 'tiny'
};

ClientLogo.propTypes = {
    logoPath: string,
    name: string,
    logoContainerClassName: string,
    logoClassName: string,
    size: oneOf(Object.values(ClientLogo.SIZES))
};

export default ClientLogo;
